// Override Settings
var bcSfFilterSettings = {
	general: {
		limit: bcSfFilterConfig.custom.products_per_page,
		// Optional
		loadProductFirst: false,
		numberFilterTree: 2,
		paginationType: bcSfFilterConfig.custom.infinite_scroll ? 'infinite' : 'default',
      showPlaceholderProductList: true,
      placeholderImageRatio: 1.4,
      placeholderProductGridItemClass: 'desktop-3 tablet-2 mobile-half span-3 product-index',
      placeholderProductPerRow: 4
	}
};
  
var bcSfFilterTemplate = {
    'saleLabelHtml': '<div class="sale-item icn">' + bcSfFilterConfig.label.sale + '</div>',
    'soldOutLabelHtml': '<div class="so icn">' + bcSfFilterConfig.label.sold_out + '</div>',
    'newLabelHtml': '<div class="new icn">' + bcSfFilterConfig.label.new + '</div>',
    'vendorHtml': '{{itemVendorLabel}}',
  	'inventoryHtml': '{{itemInventoryLabel}}',
  	'skuHtml': '{{itemSkuLabel}}',
    'quickViewHtml': '<div class="product-info"><a data-fancybox="quick-view-{{itemId}}" data-type="ajax" class="fancybox.ajax product-modal" rel="nofollow" href="{{itemUrl}}?view=quick">' + bcSfFilterConfig.label.quick_view + '</a></div>',
    'imageFlipHtml': '<div class="hidden"><img src="{{imageFlipUrl}}" alt="{{itemTitle}}" /></div>',
    
	'productGridItemHtml' : '<div class="'+ bcSfFilterConfig.custom.grid_item_width +' product-index" id="prod-{{itemId}}" data-alpha="{{itemTitle}}" data-price="{{itemPriceNumber}}" data-aos="' + bcSfFilterConfig.custom.scroll_animation + '" data-product-id="{{itemId}}">' +
								'<div class="ci">' +
									'{{itemNewLabel}}' +
									'{{itemSaleLabel}}' +
									'{{itemSoldoutLabel}}' +
                            	    '<a href="{{itemUrl}}" title="{{itemTitle}}">' +
										'<div class="reveal">' +
											'{{itemImages}}' +
							  			'</div>' +
                            	    '</a>' +
                            	    '{{itemQuickView}}' +
                            	'</div>' +
                            	'<div class="product-details arrival_product_content">' +
                            	    '<a href="{{itemUrl}}">' +
                            	        '<h5>{{itemTitle}}</h5>' +
                            	        
                            	    '</a>' +
  									'<p><a href="{{itemUrl}}" Class="by-text-card">By </a><a href="{{itemUrl}}">{{itemVendor}}</a></p>' +
                            	    '<div class="stock-price-con"><div class="price">{{itemPrice}}</div>' +
  									'<div class="inventory">{{itemInventory}}</div></div>' +
                            	    '<div class="product_listing_options">' +
                            	        '{{itemSizeSwatch}}' +
                            	        '{{itemColorSwatch}}' +
                            	        //'{{itemAddToCart}}' +
                            	        '{{itemReviews}}' +
                            	    '</div>' +
								'</div>' +
							'</div>',
  
    
	'productListItemHtml' : '<div class="list-view '+ bcSfFilterConfig.custom.grid_item_width +' product-index" id="prod-{{itemId}}" data-alpha="{{itemTitle}}" data-price="{{itemPriceNumber}}" data-aos="' + bcSfFilterConfig.custom.scroll_animation + '" data-product-id="{{itemId}}">' +
								'<div class="ci">' +
									'{{itemNewLabel}}' +
									'{{itemSaleLabel}}' +
									'{{itemSoldoutLabel}}' +
                            	    '<a href="{{itemUrl}}" title="{{itemTitle}}">' +
										'<div class="reveal">' +
											'{{itemImages}}' +
							  			'</div>' +
                            	    '</a>' +
                            	    '{{itemQuickView}}' +
                            	'</div>' +
                            	'<div class="product-details arrival_product_content">' +
                            	    '<a href="{{itemUrl}}">' +
                            	        '<h5>{{itemTitle}}</h5>' +
                            	        
                            	    '</a>' +
  									'<div class="main-list-con">' +
                                      '<div class="left-con">' +
                                        '<p><a href="{{itemUrl}}" Class="by-text-card">By </a><a href="{{itemUrl}}">{{itemVendor}}</a></p>' +
                                        '<div class="stock-price-con"><div class="price">{{itemPrice}}</div>' +
                                        '<div class="inventory">{{itemInventory}}</div></div>' +
                                      '</div>' +
                                      '<div class="right-con">' +
                                        '<div class="available_qty inventory-{{itemId}}" style="display:none;">' +
                                          '<div class="available_qty_heading">AVAILABLE QUANTITY BY WAREHOUSE<span class="plus">+</span><span class="minus">-</span></div>' +
                                          '<div class="available_qty_content" style="display:none"></div>' +
                                        '</div>' +
                                        '<div class="sku">' +
                                          '<label style="display: inline-block; line-height: 1.6em;">SKU:</label> <span class="variant_sku">{{itemSku}}</span>' +
                                        '</div>' +
                                        '<div class="product_listing_options">' +
                                            '{{itemSizeSwatch}}' +
                                            '{{itemColorSwatch}}' +
                                            '<div class="btn-con">' +
  											/*'<div class="product-qty selector-wrapper">' +
                                                '<h5>Quantity</h5>' +
                                                '<a class="downer quantity-control-down">-</a>' +
                                                '<input min="1" type="text" name="quantity" class="product-quantity" value="1" />' +
                                                '<a class="up quantity-control-up">+</a>' +
                                             '</div>' +
                                             '<div class="clear"></div>' +*/
                                              '{{itemAddToCart}}' +
                                              '<a href="/cart" class="cart_link">Go to Cart</a>' +
  											'</div>' +
                                            '{{itemReviews}}' +
                                        '</div>' +
                                      '</div>' +
  									'</div>' +
								'</div>' +
							'</div>',

    // Grid Template
    'productGridItemHtmlold':  '<div id="prod-{{itemId}}" class="product-index {{itemGridWidthClass}} tablet-half mobile-half" data-alpha="{{itemTitle}}" data-price="{{itemPriceNumber}}" data-aos="fadeup">' +
                                '<div class="ci">' +
                                    '{{itemNewLabel}}' +
                                    '{{itemSaleLabel}}' +
                                    '{{itemSoldoutLabel}}' +
  
                                    '<a href="{{itemUrl}}" title="{{itemTitle}}">' +
                                        '<div class="reveal">' +
                                              '{{itemImages}}' +
                                        '</div>' +
                                    '</a>' +
                                '</div>' +
  
                                '<div class="product-info">' +
                                    '{{itemQuickView}}' +
                                '</div>' +
  
                                '<div class="product-details">' +
                                    '<a href="{{itemUrl}}">' +
                                        '<h3>{{itemTitle}}</h3>' +
                                        '{{itemVendor}}' +
                                    '</a>' +
                                    '<div class="price">{{itemPrice}}</div>' +
                                '</div>' +
                            '</div>',
  
    // Pagination Template
    'previousHtml': '<a href="{{itemUrl}}"><</a>',
    'nextHtml': '<a href="{{itemUrl}}">></a>',
    'pageItemHtml': '<a href="{{itemUrl}}">{{itemTitle}}</a>',
    'pageItemSelectedHtml': '<span class="current">{{itemTitle}}</span>',
    'pageItemRemainHtml': '<span>{{itemTitle}}</span>',
    'paginateHtml': '{{previous}}{{pageItems}}{{next}}',
  
    // Sorting Template
    'sortingHtml': '<label for="bc-sf-filter-top-sorting-select">'+ bcSfFilterConfig.label.sorting + '</label><select id="bc-sf-filter-top-sorting-select" class="bc-select">{{sortingItems}}</select>',
  };

// Build Product List GRID VIEW
BCSfFilter.prototype.buildProductGridItem = function (data, index, totalProduct) {
	/*** Prepare data ***/
	var images = data.images_info;
	// Displaying price base on the policy of Shopify, have to multiple by 100
	var soldOut = !data.available; // Check a product is out of stock
	var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
	var priceVaries = data.price_min != data.price_max; // Check a product has many prices
	// Get First Variant (selected_or_first_available_variant)
	var firstVariant = data['variants'][0];
	if (getParam('variant') !== null && getParam('variant') != '') {
		var paramVariant = data.variants.filter(function (e) { return e.id == getParam('variant'); });
		if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
	} else {
		for (var i = 0; i < data['variants'].length; i++) {
			if (data['variants'][i].available) {
				firstVariant = data['variants'][i];
				break;
			}
		}
	}
	/*** End Prepare data ***/

	// Get Template
	var itemHtml = bcSfFilterTemplate.productGridItemHtml;

	// Add Label
	var itemNewLabelHtml = '';
	var itemSaleLabelHtml = '';
	var itemSoldoutLabelHtml = '';
	if (!soldOut) {
		for (var k in data.collections) {
			if (data['collections'][k]['handle'] == 'new') {
				itemNewLabelHtml = bcSfFilterTemplate.newLabelHtml;
				break;
			}
		}
		if (onSale) {
			itemSaleLabelHtml = bcSfFilterTemplate.saleLabelHtml;
		}
	} else {
		itemSoldoutLabelHtml = bcSfFilterTemplate.soldOutLabelHtml;
	}
	itemHtml = itemHtml.replace(/{{itemNewLabel}}/g, itemNewLabelHtml);
	itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);
	itemHtml = itemHtml.replace(/{{itemSoldoutLabel}}/g, itemSoldoutLabelHtml);

	// Add Vendor
	var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
	itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);
  
  	// Add Inventory
  	var itemInventoryHtml =  '';
  	if (bcSfFilterMainConfig.customer == 'yes'){
      itemInventoryHtml = data.selected_or_first_available_variant.inventory_quantity > 0 ? bcSfFilterTemplate.inventoryHtml.replace(/{{itemInventoryLabel}}/g, 'UNITS AVAILABLE: '+data.selected_or_first_available_variant.inventory_quantity) : '<a href="https://forms.office.com/Pages/ResponsePage.aspx?id=qdj07VpaX0qlY9NRdcujlUy0JsVJXGBIpTloEAJ_2gBUQUI5RlFDNUFOM0Q5S0ZEMlVaRElEV0hYUy4u" target="_blank">CONTACT US</a>';
    }
  	itemHtml = itemHtml.replace(/{{itemInventory}}/g, itemInventoryHtml);
  
	// Add price
	var itemPriceHtml = '';
    if (bcSfFilterMainConfig.customer == 'yes'){
//       console.log(data);
      if (onSale) {
          itemPriceHtml += '<div class="onsale">' + this.formatMoney(data.price_min, this.moneyFormat) + '</div>';
          itemPriceHtml += '<div class="was-listing">' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</div>'
      } else {
          itemPriceHtml += '<div class="prod-price">';
          if (priceVaries) {
              itemPriceHtml += bcSfFilterConfig.label.from_price + ' ' + this.formatMoney(data.price_min, this.moneyFormat) + ' - ' + this.formatMoney(data.price_max, this.moneyFormat);
          } else {
              itemPriceHtml += this.formatMoney(data.price_min, this.moneyFormat);
          }
          itemPriceHtml += '</div>';
      }
    }
	itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

	// Add Images
	var itemImagesHtml = '';
	if (images.length > 0){
		itemImagesHtml += buildImage(images[0]);
		if (bcSfFilterConfig.custom.image_flip_enable && images.length > 1){
			itemImagesHtml += '<div class="hidden">' + buildImage(images[1]) + '</div>';
		}
	} else {
		itemImagesHtml = buildImage(null);
	}
	itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

	// Add Quick view
	var itemQuickViewHtml = bcSfFilterConfig.custom.quick_view_enable && bcSfFilterConfig.custom.product_info != 'add_to_cart' ? bcSfFilterTemplate.quickViewHtml : '';
	itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);

	// Add size swatch
	var itemSizeSwatchHtml = buildSizeSwatch(data);
	itemHtml = itemHtml.replace(/{{itemSizeSwatch}}/g, itemSizeSwatchHtml);

	// Add color swatch
	var itemColorSwatchHtml = buildColorSwatch(data);
	itemHtml = itemHtml.replace(/{{itemColorSwatch}}/g, itemColorSwatchHtml);

	// Add add to cart
	var itemAddToCartHtml = buildAddToCart(data, firstVariant);
	itemHtml = itemHtml.replace(/{{itemAddToCart}}/g, itemAddToCartHtml);

	// Add reviews
	var itemReviewsHtml = bcSfFilterConfig.custom.show_reviews ? '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>' : '';
	itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);

	// Add Style 
  	/*
	if (index == totalProduct) {
		itemHtml += bcSfFilterConfig.custom.product_grid_styles;
	}
    */

	// Add main attribute
	itemHtml = itemHtml.replace(/{{itemPriceNumber}}/g, data.price_min);
	itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
	itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
	itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

	return itemHtml;
}

// Build Product List LIST VIEW
BCSfFilter.prototype.buildProductListItem = function (data, index, totalProduct) {
	/*** Prepare data ***/
	var images = data.images_info;
	// Displaying price base on the policy of Shopify, have to multiple by 100
	var soldOut = !data.available; // Check a product is out of stock
	var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
	var priceVaries = data.price_min != data.price_max; // Check a product has many prices
	// Get First Variant (selected_or_first_available_variant)
	var firstVariant = data['variants'][0];
	if (getParam('variant') !== null && getParam('variant') != '') {
		var paramVariant = data.variants.filter(function (e) { return e.id == getParam('variant'); });
		if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
	} else {
		for (var i = 0; i < data['variants'].length; i++) {
			if (data['variants'][i].available) {
				firstVariant = data['variants'][i];
				break;
			}
		}
	}
	/*** End Prepare data ***/

	// Get Template
	var itemHtml = bcSfFilterTemplate.productListItemHtml;

	// Add Label
	var itemNewLabelHtml = '';
	var itemSaleLabelHtml = '';
	var itemSoldoutLabelHtml = '';
	if (!soldOut) {
		for (var k in data.collections) {
			if (data['collections'][k]['handle'] == 'new') {
				itemNewLabelHtml = bcSfFilterTemplate.newLabelHtml;
				break;
			}
		}
		if (onSale) {
			itemSaleLabelHtml = bcSfFilterTemplate.saleLabelHtml;
		}
	} else {
		itemSoldoutLabelHtml = bcSfFilterTemplate.soldOutLabelHtml;
	}
	itemHtml = itemHtml.replace(/{{itemNewLabel}}/g, itemNewLabelHtml);
	itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);
	itemHtml = itemHtml.replace(/{{itemSoldoutLabel}}/g, itemSoldoutLabelHtml);

	// Add Vendor
	var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
	itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);
  
  	// Add Inventory
  	var itemInventoryHtml =  '';
  	if (bcSfFilterMainConfig.customer == 'yes'){
      itemInventoryHtml = data.selected_or_first_available_variant.inventory_quantity > 0 ? bcSfFilterTemplate.inventoryHtml.replace(/{{itemInventoryLabel}}/g, 'UNITS AVAILABLE: '+data.selected_or_first_available_variant.inventory_quantity) : '<a href="https://forms.office.com/Pages/ResponsePage.aspx?id=qdj07VpaX0qlY9NRdcujlUy0JsVJXGBIpTloEAJ_2gBUQUI5RlFDNUFOM0Q5S0ZEMlVaRElEV0hYUy4u" target="_blank">CONTACT US</a>';
    }
  	itemHtml = itemHtml.replace(/{{itemInventory}}/g, itemInventoryHtml);
  
  	// Add SKU
  	var itemSkuHtml =  '';
//   	if (bcSfFilterMainConfig.customer == 'yes'){
      itemSkuHtml = data.skus[0] != '' ? bcSfFilterTemplate.skuHtml.replace(/{{itemSkuLabel}}/g, data.skus[0]) : '';
//     }
  	itemHtml = itemHtml.replace(/{{itemSku}}/g, itemSkuHtml);
  
	// Add Quanity by Warehouse  
  	var xhr = new XMLHttpRequest();
    xhr.withCredentials = true;
    xhr.addEventListener("readystatechange", function() {
      if(this.readyState === 4) {
        if(this.responseText != 'Success'){
          var myObj = JSON.parse(this.responseText);
          var available_qty = myObj.system_products[0].variants[0].qty_availability[0].qty;
          var available_qty1 = myObj.system_products[0].variants[0].qty_availability;
          var i;
          var available_qty_source = '';
          for (i = 0; i < available_qty1.length; ++i) {
            if(available_qty1[i].qty > 0){
              available_qty_source += "<p>"+available_qty1[i].description+" : "+available_qty1[i].qty+"</p>"
            }
          }
//           console.log(available_qty_source);
          $('.available_qty.inventory-'+data.id+' .available_qty_content').html(available_qty_source);
          if (bcSfFilterMainConfig.customer == 'yes'){
            $('.available_qty.inventory-'+data.id).show();
          }
          
          var allPanels = $('.available_qty_content').hide();
          var allHeads = $('.available_qty .available_qty_heading');
          $('.available_qty.inventory-'+data.id+' .available_qty_heading').click(function() {
              if($(this).hasClass('active')) {
                allPanels.slideUp();
                $(this).toggleClass('active');
              } else {
                allPanels.slideUp();
                allHeads.removeClass('active');
                $(this).toggleClass('active');
                $(this).next().slideDown();
              }
              
              return false;
          });
        }
      }
    });
    xhr.open("GET", "https://duncanc17.sg-host.com/?sku="+data.selected_or_first_available_variant.id);
    xhr.send();
  	
  
	// Add price
	var itemPriceHtml = '';
    if (bcSfFilterMainConfig.customer == 'yes'){
//       console.log(data);
      if (onSale) {
          itemPriceHtml += '<div class="onsale">' + this.formatMoney(data.price_min, this.moneyFormat) + '</div>';
          itemPriceHtml += '<div class="was-listing">' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</div>'
      } else {
          itemPriceHtml += '<div class="prod-price">';
          if (priceVaries) {
              itemPriceHtml += bcSfFilterConfig.label.from_price + ' ' + this.formatMoney(data.price_min, this.moneyFormat) + ' - ' + this.formatMoney(data.price_max, this.moneyFormat);
          } else {
              itemPriceHtml += this.formatMoney(data.price_min, this.moneyFormat);
          }
          itemPriceHtml += '</div>';
      }
    }
	itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

	// Add Images
	var itemImagesHtml = '';
	if (images.length > 0){
		itemImagesHtml += buildImage(images[0]);
		if (bcSfFilterConfig.custom.image_flip_enable && images.length > 1){
			itemImagesHtml += '<div class="hidden">' + buildImage(images[1]) + '</div>';
		}
	} else {
		itemImagesHtml = buildImage(null);
	}
	itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

	// Add Quick view
	var itemQuickViewHtml = bcSfFilterConfig.custom.quick_view_enable && bcSfFilterConfig.custom.product_info != 'add_to_cart' ? bcSfFilterTemplate.quickViewHtml : '';
	itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);

	// Add size swatch
	var itemSizeSwatchHtml = buildSizeSwatch(data);
	itemHtml = itemHtml.replace(/{{itemSizeSwatch}}/g, itemSizeSwatchHtml);

	// Add color swatch
	var itemColorSwatchHtml = buildColorSwatch(data);
	itemHtml = itemHtml.replace(/{{itemColorSwatch}}/g, itemColorSwatchHtml);

	// Add add to cart
	var itemAddToCartHtml = buildAddToCart(data, firstVariant);
	itemHtml = itemHtml.replace(/{{itemAddToCart}}/g, itemAddToCartHtml);

	// Add reviews
	var itemReviewsHtml = bcSfFilterConfig.custom.show_reviews ? '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>' : '';
	itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);

	// Add Style 
  	/*
	if (index == totalProduct) {
		itemHtml += bcSfFilterConfig.custom.product_grid_styles;
	}
    */

	// Add main attribute
	itemHtml = itemHtml.replace(/{{itemPriceNumber}}/g, data.price_min);
	itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
	itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
	itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

	return itemHtml;
}

function buildImage(image) {
	var html = '<div class="box-ratio" style="padding-bottom: {{imagePadding}};">' +
					'<img class="lazyload lazyload-fade" ' +
						'id="{{imageId}}" ' +
						'data-src="{{imageUrl}}" ' +
						'data-sizes="auto" ' +
						'alt="{{itemTitle}}"> ' +
				'</div>';
	if (image && image.src){
		var imagePadding = image.height / image.width * 100;
		html = html.replace(/{{imageUrl}}/g, bcsffilter.optimizeImage(image.src, '500x'));
		html = html.replace(/{{imageId}}/g, image.id);
		html = html.replace(/{{imagePadding}}/g, imagePadding + '%');
	} else {
		html = html.replace(/{{imagePadding}}/g, '100%').replace(/{{imageId}}/g, '').replace(/{{imageUrl}}/g, bcSfFilterConfig.general.no_image_url);
	}	
	return html;
}

function buildSizeSwatch(data){
	var html = '';
	var swatchItems = [];
	var sizeOptionIndex = 0;
	if (bcSfFilterConfig.custom.product_info == 'sizes' && data.available){
		var sizeKeys = ['size', 'sizes'];
		var sizeValues = [];
		data.variants.forEach(function(variant){
			var sizeValue = null;
			variant.merged_options.forEach(function(merged_option, optionIndex){
				var key = merged_option.split(':')[0];
				var value = merged_option.split(':')[1];
				if (sizeKeys.indexOf(key.toLowerCase().trim()) != -1 && sizeValues.indexOf(value.toLowerCase().trim()) == -1){
					sizeValue = value;
					sizeValues.push(value.toLowerCase().trim());
					sizeOptionIndex = optionIndex;
				}
			})
			if (sizeValue){
				var swatchItem ='<li data-option-title="{{sizeValue}}" data-href="{{variantImage}}" class="color {{sizeValue}}">' +
									'<a href="{{variantUrl}}">{{sizeValue}}</a>' +
								  '</li>';
				
				var variantImage = variant.image ? variant.image : (data.images_info.length > 0 ? data.images_info[0].src : bcSfFilterMainConfig.general.no_image_url);
				swatchItem = swatchItem.replace(/{{variantImage}}/g, bcsffilter.optimizeImage(variantImage, 'large'));
				swatchItem = swatchItem.replace(/{{sizeValue}}/g, sizeValue);
				swatchItem = swatchItem.replace(/{{variantUrl}}/g, '{{itemUrl}}?variant=' + variant.id);
				swatchItems.push(swatchItem);
			}
		});
		if (swatchItems.length > 0){
			html = '<div class="size-swatch"><ul data-option-index="' + sizeOptionIndex + '" class="size options">' + swatchItems.join(' ') +'</ul></div>';
		}
	}
	return html;
}

function buildColorSwatch(data){
	var html = '';
	var swatchItems = [];
	var colorOptionIndex = 0;
	if (bcSfFilterConfig.custom.product_info == 'colors' && data.available){
		var colorKeys = ['color', 'colors', 'colour' ,'colours'];
		var colorValues = [];
		data.variants.forEach(function(variant){
			var colorValue = null;
			variant.merged_options.forEach(function(merged_option, optionIndex){
				var key = merged_option.split(':')[0];
				var value = merged_option.split(':')[1];
				if (colorKeys.indexOf(key.toLowerCase().trim()) != -1 && colorValues.indexOf(value.toLowerCase().trim()) == -1){
					colorValue = value;
					colorValues.push(value.toLowerCase().trim());
					colorOptionIndex = optionIndex;
				}
			})
			if (colorValue){
				var swatchItem ='<li data-option-title="{{colorValue}}" data-href="{{variantImage}}" class="color {{colorValue}}">' +
									'<a href="{{variantUrl}}">' +
				  						(bcSfFilterConfig.custom.color_swatch_options == 'variant-image' && variant.image ?
											'<img class="variant-image" src="{{variantImage}}" alt="{{colorValue}}">'
				  							:
					  						'<span class="custom-image css-color" style="width: 25px; height: 25px; '+
					  						'background-color: {{backgroundColor}}; background-image: url({{backgroundImage}});">' +								
											'</span>'
										) +				  
									'</a>'
			  					'</li>';
				
				var variantImage = variant.image ? variant.image : (data.images_info.length > 0 ? data.images_info[0].src : bcSfFilterMainConfig.general.no_image_url);
				swatchItem = swatchItem.replace(/{{variantImage}}/g, bcsffilter.optimizeImage(variantImage, 'large'));				
				swatchItem = swatchItem.replace(/{{variantUrl}}/g, '{{itemUrl}}?variant=' + variant.id);
				swatchItem = swatchItem.replace(/{{colorValue}}/g, colorValue);
				swatchItem = swatchItem.replace(/{{backgroundColor}}/g, bcsffilter.slugify(colorValue).split('-').pop());
				
				var backgroundImage = bcSfFilterMainConfig.general.file_url.split('?')[0] + bcsffilter.slugify(colorValue) + '.png';
				swatchItem = swatchItem.replace(/{{backgroundImage}}/g, backgroundImage);
				swatchItems.push(swatchItem);
			}
		});
		if (swatchItems.length > 0){
			html = '<div class="col-swatch"><ul data-option-index="' + colorOptionIndex + '" class="size options">' + swatchItems.join(' ') +'</ul></div>';
		}
	}
	return html;
}

function buildAddToCart(data, firstVariant){
	var html = '';
//   console.log(data);
  	if (bcSfFilterMainConfig.customer == 'yes'){
// 	if (bcSfFilterConfig.custom.product_info == 'add_to_cart' && !bcSfFilterConfig.custom.quick_view_enable){
		html = '<div class="quick-add-to-cart">';
		if (data.variants && data.variants.length <= 1 && data.available && firstVariant){
			html += '<form action="/cart/add" method="post" data-money-format="' + bcSfFilterMainConfig.shop.money_format + '" data-product-id="{{itemId}}" enctype="multipart/form-data" class="product_form">' +
						'<div class="product-variants"></div>' +
						'<input  type="hidden" id="' + firstVariant.id + '" name="id" data-sku="' + firstVariant.sku +'" value="'+ firstVariant.id +'" />' +
						'<div class="product-add">' +
							'<input type="submit" name="button" class="add clearfix AddtoCart" value="'+ bcSfFilterConfig.label.add_to_cart +'" />' +
						'</div>' +
		  			'</form>';
		} else {
			html += '<div class="product-add">' +
						'<a class="add options button clearfix" href="{{itemUrl}}">' + bcSfFilterConfig.label.select_options + '</a>' +
		  			'</div>';
		}
	  	html += '</div>';
	  
// 	}
    }
	return html;
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function (totalProduct) {
	// Get page info
	var currentPage = parseInt(this.queryParams.page);
	var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

	// If it has only one page, clear Pagination
	if (totalPage == 1) {
		jQ(this.selector.bottomPagination).html('');
		return false;
	}

	if (this.getSettingValue('general.paginationType') == 'default') {
		var paginationHtml = bcSfFilterTemplate.paginateHtml;

		// Build wrapper
		paginationHtml = paginationHtml.replace(/{{paginateWrapperClass}}/g, 'twelve');

		// Build Previous
		var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousHtml : '';
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

		// Build Next
		var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextHtml : '';
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);

		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}

		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

		paginationHtml = jQ.parseHTML(paginationHtml);
		jQ(this.selector.bottomPagination).html(paginationHtml);
	}
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function () {
	if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
		jQ(this.selector.topSorting).html('');

		var sortingArr = this.getSortingList();
		if (sortingArr) {
			// Build content 
			var sortingItemsHtml = '';
			for (var k in sortingArr) {
				sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
			}
			var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			html = jQ.parseHTML(html);
			jQ(this.selector.topSorting).html(html);

			// Set current value
			jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
		}
	}
};

// Build Display type
// BCSfFilter.prototype.buildFilterDisplayType = function() {
//   var itemHtml = '<span>View As </span>';
//   itemHtml += '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="bc-sf-filter-display-item bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><span class="fallback-text">Grid view</span></span></a>';
//   itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="bc-sf-filter-display-item bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><span class="fallback-text">List view</span></span></a>';
//   jQ(this.selector.topDisplayType).html(itemHtml);

//   // Active current display type
//   jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
//   jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
//   if (this.queryParams.display == 'list') {
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
//   } else if (this.queryParams.display == 'grid') {
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
//   }
// };

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function (data) { 
	//bcProductQuickView();
};

// Capitalize label of filter option
BCSfFilter.prototype.buildAdditionalElements = function (data, eventType) {
	var from = this.queryParams.page == 1 ? this.queryParams.page : (this.queryParams.page - 1) * this.queryParams.limit + 1;
	var to = this.queryParams.page * this.queryParams.limit;
	var html = bcSfFilterConfig.label.showing_items + ' ' + from + '-' + to + ' / ' + data.total_product;
	html = jQ.parseHTML(html);
//   console.log(html);
	jQ(this.selector.bottomPagination).find('.count').html(html);
	
	if (window.SPR) {
		SPR.initDomEls();
		SPR.loadBadges();
	}
	if (window.AOS) {
		AOS.refreshHard();
	}
}; 

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};

function customizeJsonProductData(data) {for (var i = 0; i < data.variants.length; i++) {var variant = data.variants[i];var featureImage = data.images.filter(function(e) {return e.src == variant.image;});if (featureImage.length > 0) {variant.featured_image = {"id": featureImage[0]['id'],"product_id": data.id,"position": featureImage[0]['position'],"created_at": "","updated_at": "","alt": null,"width": featureImage[0]['width'], "height": featureImage[0]['height'], "src": featureImage[0]['src'], "variant_ids": [variant.id]}} else {variant.featured_image = '';};};var self = bcsffilter;var itemJson = {"id": data.id,"title": data.title,"handle": data.handle,"vendor": data.vendor,"variants": data.variants,"url": self.buildProductItemUrl(data),"options_with_values": data.options_with_values,"images": data.images,"images_info": data.images_info,"available": data.available,"price_min": data.price_min,"price_max": data.price_max,"compare_at_price_min": data.compare_at_price_min,"compare_at_price_max": data.compare_at_price_max};return itemJson;};
BCSfFilter.prototype.prepareProductData=function(data){var self=this;var countData=data.length;for(var k=0;k<countData;k++){data[k]["images"]=data[k]["images_info"];if(data[k]["images"].length>0){data[k]["featured_image"]=data[k]["images"][0]}else{data[k]["featured_image"]={src:bcSfFilterConfig.general.no_image_url,width:"",height:"",aspect_ratio:0}}data[k]["url"]="/products/"+data[k].handle;var optionsArr=[];var countOptionsWithValues=data[k]["options_with_values"].length;for(var i=0;i<countOptionsWithValues;i++){optionsArr.push(data[k]["options_with_values"][i]["name"])}data[k]["options"]=optionsArr;var firstVariant=data[k]["variants"][0];var isRoundedPrice=true;if(firstVariant.hasOwnProperty("fulfillment_service")&&firstVariant.fulfillment_service=="gift_card"){isRoundedPrice=false}if(typeof self.convertPriceBasedOnActiveCurrency!=="undefined"){data[k].price_min=self.convertPriceBasedOnActiveCurrency(data[k].price_min,isRoundedPrice);data[k].price_max=self.convertPriceBasedOnActiveCurrency(data[k].price_max,isRoundedPrice);data[k].compare_at_price_min=self.convertPriceBasedOnActiveCurrency(data[k].compare_at_price_min,isRoundedPrice);data[k].compare_at_price_max=self.convertPriceBasedOnActiveCurrency(data[k].compare_at_price_max,isRoundedPrice)}data[k]["price_min"]*=100,data[k]["price_max"]*=100;if(data[k]["compare_at_price_min"]!=null){data[k]["compare_at_price_min"]*=100}if(data[k]["compare_at_price_max"]!=null){data[k]["compare_at_price_max"]*=100}data[k]["price"]=data[k]["price_min"];data[k]["compare_at_price"]=data[k]["compare_at_price_min"];data[k]["price_varies"]=data[k]["price_min"]!=data[k]["price_max"];if(getParam("variant")!==null&&getParam("variant")!=""){var paramVariant=data[k]["variants"].filter(function(e){return e.id==getParam("variant")});if(typeof paramVariant[0]!=="undefined")firstVariant=paramVariant[0]}else{var countVariants=data[k]["variants"].length;for(var i=0;i<countVariants;i++){if(data[k]["variants"][i].available){firstVariant=data[k]["variants"][i];break}}}data[k]["selected_or_first_available_variant"]=firstVariant;var countVariants=data[k]["variants"].length;for(var i=0;i<countVariants;i++){var variantOptionArr=[];var count=1;var variant=data[k]["variants"][i];var variantOptions=variant["merged_options"];if(Array.isArray(variantOptions)){var countVariantOptions=variantOptions.length;for(var j=0;j<countVariantOptions;j++){var temp=variantOptions[j].split(":");data[k]["variants"][i]["option"+(parseInt(j)+1)]=temp[1];data[k]["variants"][i]["option_"+temp[0]]=temp[1];variantOptionArr.push(temp[1])}data[k]["variants"][i]["options"]=variantOptionArr}if(data[k]["variants"][i]["compare_at_price"]!=null){var variantCompareAtPrice=parseFloat(data[k]["variants"][i]["compare_at_price"]);if(typeof self.convertPriceBasedOnActiveCurrency!=="undefined"){variantCompareAtPrice=self.convertPriceBasedOnActiveCurrency(variantCompareAtPrice,isRoundedPrice)}data[k]["variants"][i]["compare_at_price"]=variantCompareAtPrice*100}var variantPrice=parseFloat(data[k]["variants"][i]["price"]);if(typeof self.convertPriceBasedOnActiveCurrency!=="undefined"){variantPrice=self.convertPriceBasedOnActiveCurrency(variantPrice,isRoundedPrice)}data[k]["variants"][i]["price"]=variantPrice*100}data[k]["description"]=data[k]["content"]=data[k]["body_html"];if(data[k].hasOwnProperty("original_tags")&&data[k]["original_tags"].length>0){data[k]["tags"]=data[k]["original_tags"].slice(0)}data[k]["json"]=customizeJsonProductData(data[k])}return data};

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
